var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 64,
    viewBox: "0 0 89 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6151 12.9276L37.8647 61.6767C36.4021 63.1393 34.4822 63.8753 32.5624 63.8753C30.6425 63.8753 28.7227 63.1393 27.2601 61.6767L2.88556 37.3022C-0.0477905 34.3702 -0.0477905 29.6296 2.88556 26.6976C5.81753 23.7643 10.5568 23.7643 13.4901 26.6976L32.5624 45.7699L76.0106 2.32306C78.9425 -0.610291 83.6818 -0.610291 86.6151 2.32306C89.5471 5.25503 89.5471 9.99426 86.6151 12.9276Z",
    fill: "url(#paint0_linear_5925_21704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5925_21704",
    x1: 44.7498,
    y1: 0.123047,
    x2: 44.7498,
    y2: 63.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87F259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FEDBF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.a0d9da1578ac79a34e93f4aea3930c57.svg";
export { ForwardRef as ReactComponent };